import {combineReducers} from 'redux';

import ingestReport from '@pluto/ingest-validation-report/Redux/IngestReportReducer';
import {qcReportsStatuses} from '@pluto/qc-reports-statuses';
import {timespanCategories} from '@pluto/timespan-categories';
import contentItemViewMetadata from 'ContentItemView/ContentItemViewMetadata/Redux/ContentItemViewMetadataReducer';
import contentItemViewArtwork from 'ContentItemView/ContentItemViewArtwork/Redux/ContentItemViewArtworkReducer';
import contentItemViewTitles from 'ContentItemView/ContentItemViewTitles/Redux/ContentItemViewTitleReducer';
import publishingRights from 'ContentItemView/ContentItemViewPublishingRights/Redux/ContentItemViewPublishingRightsReducer';
import statusIndicators, {jobDeliveryStatus,} from 'ContentItemView/Redux/ContentItemViewReducer';
import contentItemViewWorkHistory from 'ContentItemView/ContentItemViewWorkHistory/Redux/ContentItemViewWorkHistoryReducer';

const contentItemViewStore = combineReducers({
    contentItemViewArtwork,
    contentItemViewMetadata,
    ingestReport,
    qcReportsStatuses,
    publishingRights,
    statusIndicators,
    timespanCategories,
    jobDeliveryStatus,
    contentItemViewTitles,
    contentItemViewWorkHistory,
});

export default contentItemViewStore;
